import { FormControl, FormLabel, Stack } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider'
import { DateRange } from '@mui/x-date-pickers-pro/models'
import { MultiInputDateRangeField } from '@mui/x-date-pickers-pro/MultiInputDateRangeField'
import dayjs, { Dayjs } from 'dayjs'
import { useField } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const LastUpdatedFilter = () => {
  const { t } = useTranslation('@cibo/landmanager/LastUpdatedFilter')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [updatedGt, { value: lastUpdatedGt }, { setValue: setLastUpdatedGt }] =
    useField('lastUpdatedGt')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [updatedLt, { value: lastUpdatedLt }, { setValue: setLastUpdatedLt }] =
    useField('lastUpdatedLt')

  const [value, setValue] = useState<DateRange<Date | Dayjs>>([
    lastUpdatedGt ? new Date(lastUpdatedGt) : null,
    lastUpdatedLt ? new Date(lastUpdatedLt) : null,
  ])

  const handleChangeDateRange = (newRange: [Date | Dayjs | null, Date | Dayjs | null]) => {
    setValue(newRange)
    setLastUpdatedGt(newRange[0] === null ? undefined : dayjs(newRange[0]).format('YYYY-MM-DD'))
    setLastUpdatedLt(newRange[1] === null ? undefined : dayjs(newRange[1]).format('YYYY-MM-DD'))
  }

  return (
    <FormControl>
      <FormLabel>{t('lastUpdated')}</FormLabel>
      <Stack spacing={1}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateRangePicker
            value={value}
            onChange={handleChangeDateRange}
            slots={{ field: MultiInputDateRangeField }}
            slotProps={{
              field: {
                dateSeparator: 'to',
              },
              textField: {
                hiddenLabel: true,
                size: 'small',
              },
            }}
          />
        </LocalizationProvider>
      </Stack>
    </FormControl>
  )
}
